import Axios from "axios";
import ApiClient from './ApiClient'

export default class UserService {

    constructor() {
        this.apiClient = new ApiClient();
     }

    getUserDetails() {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/user', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
    }

    saveUserDetails(user) {
        return Axios.post(process.env.VUE_APP_API_BASE_URL + '/user', user, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
    }

    saveUserPhoto(photo) {
        return Axios.post(process.env.VUE_APP_API_BASE_URL + '/userphoto', photo, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
    }

    ping() {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/auth/amiloggedin', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
    }

    changeEmail(email, password) {
        return this.apiClient.createAuthed().post('/user/username', {
            email,
            password
        });
    }

    changePassword(oldPassword, newPassword) {
        return this.apiClient.createAuthed().post('/user/password', {
            CurrentPassword: oldPassword,
            newPassword
        })
    }

}